import Vue from "vue"
import Vuex from "vuex"

import User from "./user"
import Site from "./site"
import Folder from "./folder"
import AddEmail from "./addEmail"

Vue.use(Vuex)

// 全局store
const store = new Vuex.Store({
  modules: {
    User,
    Site,
    Folder,
    AddEmail
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js